<!-- explain - why [ 说明 - 为什么 ] -->
<template>

    <div id='explainWhy'>

         <!-- title -->
        <h1>为什么会出现“存入零钱”？</h1>

        <!-- content -->
        <div class="content">
            <p>当用户本年度用量超出标准范围后，应当补交相应的阶梯差价。阶梯差价根据超出度数不同，则差价不同，有时会是整数，有时会带有小数。因电表暂不支持充值小数金额，所以当自动扣除差价时，系统会自动进位到整数位进行扣除。那么多扣用户的那部分小数金额会以“零钱”的方式补充到您的APP中。这部分零钱累计满1元时，会自动充值到您的电表中。</p>

            <el-collapse v-model="activeNames" @change="handleChange" style="margin-top: 30px;">

                <el-collapse-item title="举例说明：" name="1">
                    <p>补交阶梯差价 = 1.5元</p>
                    <p>充值缴费金额 = 100元</p>
                    <p>系统自动抵扣差价 = 2.0元</p>
                    <p>存入零钱 = 系统自动抵扣差价-补交阶梯差价</p>
                    <p>即：存入零钱 = 0.5元</p>
                </el-collapse-item>

            </el-collapse>
        </div>

    </div>

</template>

<script>
export default {
    components: { },

    props: [],

    data() {
        return{
            activeNames: ['1'],
        }
    },

    computed: { },

    watch: {
        route: {
            handler: function(val, old){

            },
            deep: true
        }
    },

    created(){

    },

    mounted(){
        this.loadMain();

        this.getData();
    },

    methods:{
        loadMain(){

        },

        getData(){

        },
    },
}
</script>

<style scoped>
    body, html{
        margin: 0;
        padding: 0;
    }

    h1{
        padding: 30px 0;
        text-align: center;
        font-weight: 500;
    }

    .content{
        margin: auto;
        padding: 20px 0;
        width: 1200px;
    }

    .content > p{
        line-height: 30px;
        text-indent: 2em;
    }
</style>


// WEBPACK FOOTER //
// explainWhy.vue?26676fd4